// slider/index.recipe.ts
import {defineSlotRecipe} from '@chakra-ui/react3'

export const sliderSlotRecipe = defineSlotRecipe({
    className: 'slider',
    slots: [
        'sliderContainer',
        'controlsContainer',
        'pagination',
        'slide',
        'videoControlContainer',
        'scrollContainer',
        'navButton'
    ],

    base: {
        sliderContainer: {
            position: 'relative',
            flexDirection: 'column-reverse',
            overflow: 'visible',
            // default values
            '--items-per-slide': 1,
            '--slide-gap': 'sizes.8' // = gap (fallback)
        },
        scrollContainer: {
            // matches the container inline padding from ModuleContainer
            '--container-inline-padding': {
                base: 'spacing.spacing-24',
                s: 'spacing.spacing-90'
            },
            overflowX: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {display: 'none'},
            WebkitOverflowScrolling: 'touch',
            // for full visible focus indicator for (first) visible element
            paddingY: 'spacing-4'
        },
        controlsContainer: {
            paddingTop: {base: 'spacing-40', s: 'spacing-80'},
            zIndex: 2
        },
        slide: {
            flex: '0 0 auto',
            height: 'auto',
            position: 'relative',
            overflow: 'visible',
            width: 'calc((100% - ( (var(--items-per-slide) - 1) * var(--slide-gap) )) / var(--items-per-slide))',
            img: {pointerEvents: 'none', userSelect: 'none', draggable: false}
        },
        pagination: {gap: '2px', justifyContent: 'center'},
        navButton: {
            size: 'md'
        }
    },

    variants: {
        variant: {
            carousel: {
                controlsContainer: {justifyContent: 'flex-end'},
                scrollContainer: {
                    // using container units and negative margin to span
                    // the full visible width but without the scrollbars
                    marginInline: 'calc(-50cqw + 50%)',
                    // get the size as css var to use in the computations below
                    '--max-container-width': 'sizes.container-page-max-width',
                    // offset children so they are aligned with the module content
                    // we need the module container inline padding and because
                    // the module container has max-width we add half of the
                    // difference between the inline query container size and
                    // max module width
                    paddingInline:
                        'calc(var(--container-inline-padding) + max(0px, calc(100cqw - var(--max-container-width))) * 0.5)',
                    scrollPaddingInline:
                        'calc(var(--container-inline-padding) + max(0px, calc(100cqw - var(--max-container-width))) * 0.5)'
                },
                pagination: {display: 'none'},
                navButton: {variant: 'secondaryGhost'}
            },
            gallery: {
                slide: {width: {base: '100vw', s: '100%'}},
                scrollContainer: {
                    position: 'relative',
                    marginInline: {base: 'calc(-1 * var(--container-inline-padding))', s: 0}
                },
                controlsContainer: {
                    flexDirection: {base: 'row-reverse', s: 'revert'},
                    justifyContent: 'space-between',
                    position: 'absolute',
                    left: 'spacing-32',
                    bottom: 'spacing-32',
                    right: {base: 'spacing-32', s: 'auto'},
                    gap: {base: 0, s: 'spacing-32'}
                },
                videoControlContainer: {
                    position: {base: 'absolute', s: 'relative'},
                    top: 'spacing-8',
                    right: 'spacing-8',
                    zIndex: '1'
                },
                navButton: {variant: 'mediaGhost'}
            }
        }
    },

    defaultVariants: {variant: 'default'}
})
